import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

const localHostDomain = 'licenta-demo-api.codern.eu'
export const domainName = localHostDomain;

export const apiUrl = `https://${domainName}/api/v1/`;

export const apiEndpoints = {

    accounts: apiUrl + 'users',
    apiVersion: `https://${domainName}/api/api-version`,

    allergens: apiUrl + 'allergens',

    assets: apiUrl + 'assets',
    assetTypes: apiUrl + 'asset-types',

    brandInvoiceProfiles: apiUrl + 'brand-invoice-profiles',
    brandProfile: apiUrl + 'brand-profile',
    brandProfileAdditionalDetails: apiUrl + 'brand-profile-additional-details',
    brandProfileLogoAndCover: apiUrl + 'brand-profile-logo-and-cover',
    brandProfileSettings: apiUrl + 'brand-profile-settings',
    brandProfileLogoDelete: apiUrl + 'brand-profile-logo',
    brandProfileCoverDelete: apiUrl + 'brand-profile-cover',

    categories: apiUrl + "categories",
    customers: apiUrl + "customers",
    customerRequests: apiUrl + "customer-requests",

    productAllergens: apiUrl + "product-allergens",
    products: apiUrl + "products",
    productImage: apiUrl + "product-image",

    types: apiUrl + "types",

    measurementUnits: apiUrl + "measurement-units",

    constraints: apiUrl + 'constraints',
    owners: apiUrl + 'owners',
    ownerServices: apiUrl + 'owner-services',
    ownerInvoiceProfiles: apiUrl + 'owner-invoice-profiles',
    defaultOwnerInvoiceProfile: apiUrl + 'default-owner-invoice-profile',
    ownerProfilePicture: apiUrl + 'owner-profile-photo',

    defaultBrandInvoiceProfiles: apiUrl + 'default-brand-invoice-profile',

    emailResetLink: apiUrl + 'email-reset-link',
    enumValues: apiUrl + 'enum-values',

    genericResourceList: apiUrl + 'generic-resource-list',

    invoicePayments: apiUrl + 'invoice-payments',
    invoiceSeries: apiUrl + 'invoice-series',
    invoices: apiUrl + 'invoices',
    invoiceServices: apiUrl + 'invoice-services',

    login: apiUrl + 'login',
    logout: apiUrl + 'logout',

    locations: apiUrl + 'locations',
    locationServices: apiUrl + 'location-services',

    orders: apiUrl + 'orders',
    orderProducts: apiUrl + 'order-products',

    payments: apiUrl + 'payments',

    permission: apiUrl + 'permission',
    permissions: apiUrl + 'permissions-list',
    permissionsDetailed: apiUrl + 'permissions-detailed',

    reservations: apiUrl + 'reservations',
    reservationsGraphicalRepresentation: apiUrl + 'reservations-graphical-representation',

    recordRegisterReport: apiUrl + 'reports/record-register',
    refreshToken: apiUrl + 'refresh',
    resetPassword: apiUrl + 'reset-password',
    roles: apiUrl + 'roles',

    salesReport: apiUrl + 'sales-report',
    services: apiUrl + 'services',
    servicesCategories: apiUrl + 'services-categories',
    servicesTypes: apiUrl + 'services-types',
    sessions: apiUrl + 'sessions',

    tokenStatus: apiUrl + 'token-status',

    overdueSessions: apiUrl + 'overdue-sessions',
    ownerSessionsReport: apiUrl + 'reports/owner-sessions',
    sessionServices: apiUrl + 'session-services',
    providedSessionServices: apiUrl + 'provided-session-services',
    settings: apiUrl + 'settings',
    supportedLocales: apiUrl + 'supported-locales',
    userProfile: apiUrl + 'user',
    userProfilePicture: apiUrl + 'user-profile-photo',
    userStatuses: apiUrl + 'user-statuses',
}

export interface ApiResponse {
    success: boolean;
    data: object[] | object;
}

export interface ErrorResponse {
    message: string;
}

@Injectable({
    providedIn: 'root'
})

export class ApiRequestService {

    constructor(private _httpClient: HttpClient) { }

    submitGetRequest(url: string, options?: object): Observable<ApiResponse | any> {
        return this._httpClient.get<ApiResponse>(url, options);
    }

    submitPostRequest(url: string, payload?: object, headers?: object): Observable<ApiResponse | any> {
        return this._httpClient.post<any>(url, payload, headers);
    }

    submitPutRequest(url: string, payload: object, options?: object): Observable<ApiResponse | any> {
        return this._httpClient.put<any>(url, payload, options);
    }

    submitDeleteRequest(url: string, options?: object): Observable<ApiResponse | any> {
        return this._httpClient.delete<any>(url, options);
    }
}
